import gettingStartedArticle from './articles/getting-started.json';
import dashboardArticle from './articles/dashboard.json';
import globalSearchArticle from './articles/global_search.json';
import askInventreeArticle from './articles/ask_inventree.json';
import dataExportArticle from './articles/data_export.json';
import dataImportArticle from './articles/data_import.json';
import posArticle from './articles/pos.json';
import salesArticle from './articles/sales.json';
import multiSaleArticle from './articles/multi_sale.json';
import purchasesArticle from './articles/purchases.json';
import productsArticle from './articles/products.json';
import pricingBatchesArticle from './articles/pricing_batches.json';
import transfersArticle from './articles/transfers.json';
import damagedItemsArticle from './articles/damaged_items.json';
import supplierReturnsArticle from './articles/supplier_returns.json';
import replenishmentArticle from './articles/replenishment.json';
import shelfMapArticle from './articles/shelf_map.json';
import stockAtlasArticle from './articles/stock_atlas.json';
import cashRunwayArticle from './articles/cash_runway.json';
import suppliersArticle from './articles/suppliers.json';
import customersArticle from './articles/customers.json';
import automotivesArticle from './articles/automotives.json';
import remindersArticle from './articles/reminders.json';
import branchesArticle from './articles/branches.json';
import attributesArticle from './articles/attributes.json';
import workersArticle from './articles/workers.json';
import expensesArticle from './articles/expenses.json';
import tillsArticle from './articles/tills.json';
import cardMachinesArticle from './articles/card_machines.json';
import gatePassesArticle from './articles/gate_passes.json';
import loadFormsArticle from './articles/load_forms.json';
import deliveryPersonsArticle from './articles/delivery_persons.json';
import orderRequestsArticle from './articles/order_requests.json';
import refundReturnArticle from './articles/refund_return.json';
import stockDiscrepanciesArticle from './articles/stock_discrepancies.json';
import trashArticle from './articles/trash.json';
import reportsArticle from './articles/reports.json';
import generalLedgerArticle from './articles/general_ledger.json';
import taxLedgerArticle from './articles/tax_ledger.json';
import settingsArticle from './articles/settings.json';
import userManagementArticle from './articles/user_management.json';
import configurationsArticle from './articles/configurations.json';
import auditLogArticle from './articles/audit_log.json';
import billingArticle from './articles/billing.json';

import gettingStartedTour from './tours/getting-started.json';
import dashboardTour from './tours/dashboard.json';
import globalSearchTour from './tours/global_search.json';
import posTour from './tours/pos.json';
import salesTour from './tours/sales.json';
import multiSalesTour from './tours/multi_sales.json';
import purchasesTour from './tours/purchases.json';
import productsTour from './tours/products.json';
import transfersTour from './tours/transfers.json';
import damagedItemsTour from './tours/damaged_items.json';
import supplierReturnsTour from './tours/supplier_returns.json';
import stockAtlasTour from './tours/stock_atlas.json';
import suppliersTour from './tours/suppliers.json';
import customersTour from './tours/customers.json';
import automotivesTour from './tours/automotives.json';
import remindersTour from './tours/reminders.json';
import branchesTour from './tours/branches.json';
import attributesTour from './tours/attributes.json';
import expensesTour from './tours/expenses.json';
import gatePassesTour from './tours/gate_passes.json';
import loadFormsTour from './tours/load_forms.json';
import deliveryPersonsTour from './tours/delivery_persons.json';
import orderRequestsTour from './tours/order_requests.json';
import refundReturnTour from './tours/refund_return.json';
import stockDiscrepanciesTour from './tours/stock_discrepancies.json';
import trashTour from './tours/trash.json';
import reportsTour from './tours/reports.json';
import settingsTour from './tours/settings.json';
import userManagementTour from './tours/user_management.json';
import configurationsTour from './tours/configurations.json';
import auditLogTour from './tours/audit_log.json';

export const articles = [
    gettingStartedArticle,
    dashboardArticle,
    globalSearchArticle,
    askInventreeArticle,
    dataExportArticle,
    dataImportArticle,
    posArticle,
    salesArticle,
    multiSaleArticle,
    purchasesArticle,
    productsArticle,
    pricingBatchesArticle,
    transfersArticle,
    damagedItemsArticle,
    supplierReturnsArticle,
    replenishmentArticle,
    shelfMapArticle,
    stockAtlasArticle,
    cashRunwayArticle,
    suppliersArticle,
    customersArticle,
    automotivesArticle,
    remindersArticle,
    branchesArticle,
    attributesArticle,
    workersArticle,
    expensesArticle,
    tillsArticle,
    cardMachinesArticle,
    gatePassesArticle,
    loadFormsArticle,
    deliveryPersonsArticle,
    orderRequestsArticle,
    refundReturnArticle,
    stockDiscrepanciesArticle,
    trashArticle,
    reportsArticle,
    generalLedgerArticle,
    taxLedgerArticle,
    settingsArticle,
    userManagementArticle,
    configurationsArticle,
    auditLogArticle,
    billingArticle,
];

export const tours = [
    gettingStartedTour,
    dashboardTour,
    globalSearchTour,
    posTour,
    salesTour,
    multiSalesTour,
    purchasesTour,
    productsTour,
    transfersTour,
    damagedItemsTour,
    supplierReturnsTour,
    stockAtlasTour,
    suppliersTour,
    customersTour,
    automotivesTour,
    remindersTour,
    branchesTour,
    attributesTour,
    expensesTour,
    gatePassesTour,
    loadFormsTour,
    deliveryPersonsTour,
    orderRequestsTour,
    refundReturnTour,
    stockDiscrepanciesTour,
    trashTour,
    reportsTour,
    settingsTour,
    userManagementTour,
    configurationsTour,
    auditLogTour,
];

const tourById = Object.fromEntries(tours.map((tour) => [tour.id, tour]));
const articleById = Object.fromEntries(articles.map((article) => [article.id, article]));

/** Map vue-router route name → primary tour id for page-scoped tours. */
export const routeTourMap = {
    dashboard: 'dashboard',
    reports: 'reports',
    pos: 'pos',
    sales: 'sales',
    multi_sales: 'multi_sales',
    purchases: 'purchases',
    products: 'products',
    transfers: 'transfers',
    damaged_items: 'damaged_items',
    damaged_item_details: 'damaged_items',
    supplier_returns: 'supplier_returns',
    stock_atlas: 'stock_atlas',
    suppliers: 'suppliers',
    customers: 'customers',
    automotives: 'automotives',
    reminders: 'reminders',
    branches: 'branches',
    attributes: 'attributes',
    expenses: 'expenses',
    gate_passes: 'gate_passes',
    load_forms: 'load_forms',
    load_form_details: 'load_forms',
    delivery_persons: 'delivery_persons',
    delivery_person_details: 'delivery_persons',
    RequestOrderList: 'order_requests',
    refund_return: 'refund_return',
    stock_discrepancies: 'stock_discrepancies',
    trash: 'trash',
    settings: 'settings',
    manage_users: 'user_management',
    manage_configurations: 'configurations',
    audit_log: 'audit_log',
};

/**
 * @param {string[]} userPermissions
 * @param {{ roles?: string[], permissions?: string[] }} access
 * @param {(opts: { roles?: string[], permissions?: string[] }) => boolean} hasAccess
 */
export function canAccessHelpItem(item, hasAccess) {
    const permissions = item.permissions ?? [];
    if (!permissions.length) {
        return true;
    }

    return hasAccess({ permissions, roles: item.roles ?? [] });
}

export function getAccessibleArticles(hasAccess) {
    return articles.filter((article) => canAccessHelpItem(article, hasAccess));
}

export function getAccessibleTours(hasAccess) {
    return tours.filter((tour) => canAccessHelpItem(tour, hasAccess));
}

export function getArticle(id) {
    return articleById[id] ?? null;
}

export function getTour(id) {
    return tourById[id] ?? null;
}

export function getTourForRoute(routeName) {
    const tourId = routeTourMap[routeName];
    return tourId ? getTour(tourId) : null;
}

export function searchArticles(query, hasAccess) {
    const q = (query || '').trim().toLowerCase();
    const list = getAccessibleArticles(hasAccess);
    if (!q) {
        return list;
    }

    return list.filter((article) => {
        const haystack = [
            article.title,
            article.summary,
            article.category,
            ...(article.sections || []).flatMap((s) => [
                s.heading,
                s.body,
                ...(Array.isArray(s.items) ? s.items : []),
            ]),
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return haystack.includes(q);
    });
}

export function groupArticlesByCategory(articleList) {
    const groups = {};
    for (const article of articleList) {
        const key = article.category || 'General';
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(article);
    }
    return groups;
}
